"use strict";

jQuery(document).ready(function($) {

	// Keep the newsletter popup usable on mobile even when base.css is served
	// through a long-lived theme cache URL.
	if ( ! document.getElementById( 'popup-mobile-viewport-styles' ) ) {
		let mobilePopupStyles = document.createElement( 'style' );
		mobilePopupStyles.id = 'popup-mobile-viewport-styles';
		mobilePopupStyles.textContent = `
			@media screen and (max-width: 749px) {
				.popup-main {
					width: min(30rem, calc(100vw - 4.8rem)) !important;
					max-width: calc(100vw - 4.8rem);
					max-height: calc(100vh - 6rem);
					max-height: calc(100dvh - 6rem);
				}
				.popup-main .popup-wrap {
					max-height: calc(100vh - 6rem);
					max-height: calc(100dvh - 6rem);
					overflow-x: hidden;
					overflow-y: auto;
					overscroll-behavior: contain;
					-webkit-overflow-scrolling: touch;
				}
				.popup-main .popup-outer {
					min-width: 0;
				}
				.popup-main .popup-thumbnail {
					flex: 0 0 auto;
					width: 100%;
					height: clamp(7.2rem, 14dvh, 12rem);
					min-height: 0;
					max-height: 14dvh;
					padding-bottom: 0;
				}
				.popup-main .popup-thumbnail img {
					width: 100%;
					height: 100%;
					max-height: 14dvh;
					object-fit: cover;
				}
				.popup-main .popup-content,
				.popup-main--no-image .popup-content {
					flex: 0 0 auto;
					min-width: 0;
					padding: 1rem 1.2rem 1.2rem;
				}
				.popup-main .popup-heading {
					margin-bottom: 0.5rem;
					font-size: clamp(1.9rem, 5.5vw, 2.2rem);
					line-height: 1.15;
				}
				.popup-main .popup-description {
					margin-bottom: 0.8rem;
					font-size: 1.2rem;
					line-height: 1.4;
				}
				.popup-main .popup-text {
					margin-top: 0.6rem;
					font-size: 1rem;
					line-height: 1.4;
				}
				.popup-main .newsletter-form .field,
				.popup-main .newsletter-form .button {
					min-height: 3.8rem;
				}
				.popup-main .newsletter-form .field__input {
					height: 3.8rem;
					min-height: 3.8rem;
					padding: 0 1rem;
					font-size: 1.2rem;
				}
				.popup-main .list-social {
					gap: 0.6rem;
					margin-top: 0.8rem;
				}
				.popup-main .list-social__link {
					padding: 0.4rem;
				}
				.popup-main .list-social__link .icon {
					width: 2.8rem;
					min-width: 2.8rem;
					height: 2.8rem;
					min-height: 2.8rem;
				}
			}
			@media screen and (max-width: 749px) and (max-height: 700px) {
				.popup-main .popup-thumbnail {
					height: clamp(6.4rem, 10dvh, 9rem);
					max-height: 10dvh;
				}
				.popup-main .popup-thumbnail img {
					max-height: 10dvh;
				}
				.popup-main .popup-content,
				.popup-main--no-image .popup-content {
					padding: 0.8rem 1rem 1rem;
				}
			}
		`;
		document.head.appendChild( mobilePopupStyles );
	}

	var adpPopup = {};

	( function() {
		var $this;

		adpPopup = {
			sPrevious : window.scrollY,
			sDirection: 'down',

			/*
			* Initialize
			*/
			init: function( e ) {
				$this = adpPopup;

				$this.popupInit( e );

				// Init events.
				$this.events( e );
			},

			/*
			* Events
			*/
			events: function( e ) {
				// Custom Events
				$( document ).on( 'click', '.popup-close', $this.closePopup );
				$( document ).on( 'click', '.popup-accept', $this.acceptPopup );
				$( document ).on( 'click', '.popup-accept', $this.closePopup );
				$( document ).on( 'click', '.age-verification__popup-close', $this.agePopup );
				$( document ).on( 'click', '.age-verification__popup-close', $this.closePopup );
				$( document ).on( 'click', '.age-verification__button-no', $this.ageDeclined );

				// Checking this will cause popup to close when user presses key.
				$( document ).keyup(function(e) {
					// Press ESC to Close.
					if ( e.key === 'Escape' ) {
						$( '.popup-open[data-esc-close="true"]' ).each(function(index, popup) {
							$this.closePopup(popup);
						});
					}

					// Press F4 to Close.
					if ( e.key === 'F4' ) {
						$( '.popup-open[data-f4-close="true"]' ).each(function(index, popup) {
							$this.closePopup(popup);
						});
					}
				});

				// Checking this will cause popup to close when user clicks on overlay.
				$( document ).on( 'click', '.popup-overlay', function( e ) {
					$( '.popup-open[data-overlay-close="true"]' ).each(function(index, popup) {
						$this.closePopup(popup);
						//$this.closePopup( $( this).prev() );
					})
				} );
			},

			/*
			* Init popup elements
			*/
			popupInit: function( e ) {

				// Set scroll direction.
				$( document ).on( 'scroll', function() {

					let scrollCurrent = window.scrollY;

					// Set scroll temporary vars.
					if ( scrollCurrent > $this.sPrevious ) {
						$this.sDirection = 'down';
					} else {
						$this.sDirection = 'up';
					}

					$this.sPrevious = scrollCurrent;
				});

				// Open popup
				$( '.popup' ).each(function(index, popup) {

					// Manual Launch.
					if ( 'manual' === $( popup ).data( 'open-trigger' ) ) {

						let selector = $( popup ).data( 'open-manual-selector' );

						if ( selector ) {
							$(selector).addClass('popup-trigger')

							$( document ).on( 'click', selector, function( e ) {
								e.preventDefault();

								$( popup ).removeClass( 'popup-already-opened' );

								$this.openPopup( popup );

								if (e.currentTarget.classList.contains('popup')) {
									$this.closePopup(selector);
								}
							} );
						}


					}

					// Checks whether a popup should be displayed or not.
					if ( ! $this.isAllowPopup( popup ) && ! $(popup).hasClass('age-verification')) {
						return;
					}

					$this.openTriggerPopup( popup );
				});
			},

			/*
			* Trigger open popup
			*/
			openTriggerPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;


				var trigger = $( popup ).data( 'open-trigger' );

				// Age Verification.
				if ( 'none' === trigger ) {
					let ageVerification = $this.getStorage( 'popup-age-' + $( popup ).data( 'id' ) || 0 );


					if (!ageVerification) 
						$this.openPopup( popup );
				}

				// Time Delay.
				if ( 'delay' === trigger ) {
					let delaySeconds = parseFloat( $( popup ).data( 'open-delay-number' ) ) || 0;
					let isMobileViewport = window.matchMedia && window.matchMedia( '(max-width: 749px)' ).matches;
					if ( isMobileViewport && ! $( popup ).hasClass( 'age-verification' ) ) {
						let openAfterInteraction = function() {
							window.removeEventListener( 'pointerdown', openAfterInteraction );
							window.removeEventListener( 'keydown', openAfterInteraction );
							window.removeEventListener( 'touchstart', openAfterInteraction );

							setTimeout( function() {
								$( popup ).addClass( 'popup-mobile-interaction-ready' );
								$this.openPopup( popup );
							}, Math.max( delaySeconds, 1 ) * 1000 );
						};

						window.addEventListener( 'pointerdown', openAfterInteraction, { once: true, passive: true } );
						window.addEventListener( 'keydown', openAfterInteraction, { once: true } );
						window.addEventListener( 'touchstart', openAfterInteraction, { once: true, passive: true } );
						return;
					}

					setTimeout( function() {

						$this.openPopup( popup );

					}, delaySeconds * 1000 );
				}

				// Exit Intent.
				if ( 'exit' === trigger ) {
					var showExit = true;
					document.addEventListener( "mousemove", function( e ) {
						// Get current scroll position
						var scroll = window.pageYOffset || document.documentElement.scrollTop;
						if ( ( e.pageY - scroll ) < 7 && showExit ) {
							$this.openPopup( popup );
							showExit = false;
						}
					} );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = $( popup ).data( 'open-scroll-type' );
					var pointScrollPosition = $( popup ).data( 'open-scroll-position' );

					// Event scroll.
					$( document ).on( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( window.scrollY >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( $this.getScrollPercent() >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}
					} );
				}

				// Accept Agreement.
				if ( 'accept' === trigger ) {
					let accept = $this.getStorage( 'popup-accept-' + $( popup ).data( 'id' ) || 0 );

					if ( ! accept ) {
						$this.openPopup( popup );
					}
				}
			},

			/*
			* Trigger close popup
			*/
			closeTriggerPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				var trigger = $( popup ).data( 'close-trigger' );

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.closePopup(popup);

					}, $( popup ).data( 'close-delay-number' ) * 1000 );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = $( popup ).data( 'close-scroll-type' );
					var pointScrollPosition = $( popup ).data( 'close-scroll-position' );
					var initScrollPx        = $( popup ).data( 'init-scroll-px' );
					var initScrollPercent   = $( popup ).data( 'init-scroll-percent' );

					// Event scroll.
					$( document ).on( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( 'up' === $this.sDirection && window.scrollY < ( initScrollPx - pointScrollPosition ) ) {
								$this.closePopup( popup );
							}

							if ( 'down' === $this.sDirection && window.scrollY >= ( initScrollPx + pointScrollPosition ) ) {
								$this.closePopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( 'up' === $this.sDirection && $this.getScrollPercent() < ( initScrollPercent - pointScrollPosition ) ) {
								$this.closePopup(popup);
							}

							if ( 'down' === $this.sDirection && $this.getScrollPercent() >= ( initScrollPercent + pointScrollPosition ) ) {
								$this.closePopup(popup);
							}
						}
					} );
				}
			},

			/*
			* Open popup
			*/
			openPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				if ( $( popup ).hasClass( 'popup-open' ) ) {
					return;
				}

				// Check already opened.
				if ( $( popup ).hasClass( 'popup-already-opened' ) ) {
					return;
				}

				// Hide body scroll.
				if ( $( popup ).is( '[data-body-scroll-disable="true"]' ) ) {
					$( 'body' ).addClass( 'popup-scroll-hidden' );
				}

				// Set Storage of Limit display.
				let limit = parseInt( $this.getStorage( 'popup-' + $( popup ).data( 'id' ) ) || 0 ) + 1;

				$this.setStorage( 'popup-' + $( popup ).data( 'id' ), limit, {
					expires: $( popup ).data( 'limit-lifetime' )
				} );

				// Display popup.
				$( popup ).addClass( 'popup-open' );

				// Set current scroll.
				$( popup ).data( 'init-scroll-px', window.scrollY );
				$( popup ).data( 'init-scroll-percent', $this.getScrollPercent() );

				// Open animation.
				let animation = $( popup ).data( 'open-animation' );

				$this.applyAnimation( popup, animation );

				// Init close trigger.
				$this.closeTriggerPopup( popup );
			},

			/*
			* Age popup
			*/
			agePopup: function( e ) {
				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Set Storage of Age.
				$this.setStorage( 'popup-age-' + $( popup ).data( 'id' ), 1, {
					expires: 360
				} );
			},

			/*
			* Age declined
			*/

			ageDeclined: function() {
				$( '.age-verification__question' ).removeClass('show');
				$( '.age-verification__declined' ).addClass('show');
			},


			/*
			* Accept popup
			*/
			acceptPopup: function( e ) {

				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Set Storage of Accept.
				$this.setStorage( 'popup-accept-' + $( popup ).data( 'id' ), 1, {
					expires: 360
				} );
			},

			/*
			* Close popup
			*/
			closePopup: function( e ) {

				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Close animation.
				let animation = $( popup ).data( 'exit-animation' );

				$this.applyAnimation( popup, animation, function() {
					// Already opened.
					$( popup ).addClass( 'popup-already-opened' );

					// Hide popup.
					$( popup ).removeClass( 'popup-open' );

					// Remove classes from body.
					$( 'body' ).removeClass( 'popup-scroll-hidden' );
				} );
			},

			/*
			* Checks whether a popup should be displayed or not
			*/
			isAllowPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				// Has user seen this popup before?
				let limitDisplay = parseInt( $( popup ).data( 'limit-display' ) || 0 );

				let limitDisplayStorage = parseInt( $this.getStorage( 'popup-' + $( popup ).data( 'id' ) ) );

				if ( limitDisplay && limitDisplayStorage && limitDisplayStorage >= limitDisplay ) {
					return;
				}

				return true;
			},

			/*
			* Apply animation
			*/
			applyAnimation: function( el, name, callback ) {
				var popup = $( el ).closest( '.popup' );

				if ( typeof callback === 'function' ) {
					var overlayName = 'popupExitFade';
				} else {
					var overlayName = 'popupOpenFade';
				}

				// Overlay Animation.
				$( popup ).next( '.popup-overlay' ).addClass( 'popup-animated ' + overlayName )
					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						$( this ).removeClass( 'popup-animated ' + overlayName );
					} );

				// Wrap Animation.
				$( popup ).find( '.popup-wrap' ).addClass( 'popup-animated ' + name )
					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						// remove the animation classes after animation ends
						// required in order to apply new animation on close
						$( this ).removeClass( 'popup-animated ' + name );

						if ( typeof callback === 'function' ) {
							callback();
						}
					} );
			},

			/*
			* Get cookie
			*/
			getCookie: function (name) {
				var matches = document.cookie.match(
					new RegExp(
						'(?:^|; )' +
							name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
							'=([^;]*)'
					)
				)
				return matches ? decodeURIComponent(matches[1]) : undefined
			},

			/*
			* Set cookie
			*/
			setCookie: function (name, value, options) {
				options = options || {};

				options.path = options.hasOwnProperty('path') ? options.path : '/';

				options.expires = parseInt(options.expires);

				if (typeof options.expires == "number" && options.expires) {
					options.expires = new Date().setDate(new Date().getDate() + options.expires);
					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent(value);

				var updatedCookie = name + "=" + value;

				for (var propName in options) {
					updatedCookie += "; " + propName;
					var propValue = options[propName];
					if (propValue !== true) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			/*
			* Get local storage
			*/
			getStorage: function (key) {
				const item = localStorage.getItem(key)
				if (item) {
					try {
						const parsed = JSON.parse(item)
						if (parsed.expires && Date.now() > parsed.expires) {
							localStorage.removeItem(key)
							return undefined
						}
						return parsed.value
					} catch {
						return undefined
					}
				}
				const cookieValue = $this.getCookie(key)
				if (cookieValue !== undefined) {
					// Optional: migrate cookie to localStorage
					$this.setStorage(key, cookieValue)
					return cookieValue
				}
				return undefined
			},

			/*
			* Set local storage
			*/
			setStorage: function (key, value, options = {}) {
				const data = {
					value,
					expires: null,
				}
				if (options.expires) {
					const expiresDate = new Date()
					expiresDate.setDate(
						expiresDate.getDate() + parseInt(options.expires, 10)
					)
					data.expires = expiresDate.getTime()
				}
				localStorage.setItem(key, JSON.stringify(data))
			},

			/*
			* Get scroll percent
			*/
			getScrollPercent: function() {
				var h = document.documentElement,
					b = document.body,
					st = 'scrollTop',
					sh = 'scrollHeight';
				return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
			}
		};

	} )();

	// Initialize.
	adpPopup.init();

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init();
	});

	document.addEventListener('shopify:section:unload', function () {	
		$( 'body' ).removeClass( 'popup-scroll-hidden' );
	})
});
